// INE credencial para votar — ICAO TD1 (3 lines × 30 chars = 90 chars total)
//
// Line 1 [0–29]:  IDMEX + credential number (10) + '<<' + OCR (13)
// Line 2 [30–59]: birth date, sex, expiry, nationality
// Line 3 [60–89]: SURNAMES<<GIVEN<NAMES

export const MRZ_MX_REGEX = /^IDMEX[A-Z0-9<]{85}$/

export default function MRZMXReader(mrz) {
  const line1 = mrz.slice(0, 30)
  const line3 = mrz.slice(60, 90)

  const identification = line1.slice(5, 15).replace(/</g, '')

  const [surnames, givenNames = ''] = line3.split('<<')
  const [last_name = '', last_name_two = ''] = surnames.split('<')
  const first_name = givenNames.replace(/</g, ' ').trim()

  return { identification, first_name, last_name, last_name_two }
}
